import { Helmet } from "react-helmet-async";

const SITE_URL = "https://edugenix.online";

type PageMetaProps = {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
};

export function PageMeta({ title, description, path, noindex }: PageMetaProps) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}
    </Helmet>
  );
}